"use client";

import { useConfig } from "@/context/ConfigContext";
import { getConfigValue, getSiteName } from "@/utils/configHelper";
import { RiWhatsappLine } from "react-icons/ri";

function buildWhatsAppHref(rawNumber, siteName) {
  const text =
    typeof rawNumber === "string" ? rawNumber : String(rawNumber ?? "");
  const digits = text.replace(/[^0-9]/g, "");

  if (!digits) return null;

  const normalized = digits.startsWith("62")
    ? digits
    : digits.startsWith("0")
    ? `62${digits.slice(1)}`
    : digits.startsWith("8")
    ? `62${digits}`
    : digits;

  const message = encodeURIComponent(
    `Halo ${siteName}, saya ingin bertanya tentang toko ini.`
  );

  return `https://wa.me/${normalized}?text=${message}`;
}

export function FloatingWhatsAppButton() {
  const { config, isConfigReady } = useConfig();
  const siteName = getSiteName(config);
  const whatsappNumber = getConfigValue(config, "contact.whatsapp", null);
  const href = buildWhatsAppHref(whatsappNumber, siteName);

  if (!isConfigReady || !href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Chat WhatsApp ${siteName}`}
      title={`Chat WhatsApp ${siteName}`}
      className="fixed bottom-24 right-4 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_rgba(37,211,102,0.35)] ring-1 ring-white/70 transition hover:scale-105 hover:bg-[#1ebe5d] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 md:bottom-6 md:right-6 md:h-14 md:w-14"
    >
      <RiWhatsappLine className="h-7 w-7 md:h-8 md:w-8" aria-hidden="true" />
    </a>
  );
}
